module.exports = __webpack_public_path__ + "img/bgDrawer.4bbdb26a.jpg";